import { IUseQueryProps } from 'store/queries/types';
import { getQueryParams } from 'store/utils/getQueryParams';
import { useAppSelector } from 'store/useAppSelector';

import {
  selectIsAccountCreationAllowedLoading,
  selectIsAccountCreationAllowed,
  useFetchIsAccountCreationAllowedQuery,
  useLazyFetchIsAccountCreationAllowedQuery,
} from '../fetchIsAccountCreationAllowed';

export interface UseIsAccountCreationAllowedQueryProps extends IUseQueryProps {}

export const useIsAccountCreationAllowedQuery = ({
  skipFetching,
}: UseIsAccountCreationAllowedQueryProps = {}) => {
  useFetchIsAccountCreationAllowedQuery(
    getQueryParams({ params: undefined, skipFetching }),
  );

  const [handleFetchIsAccountCreationAllowed] =
    useLazyFetchIsAccountCreationAllowedQuery();

  const isAccountCreationAllowed = useAppSelector(
    selectIsAccountCreationAllowed,
  );

  const loading = useAppSelector(selectIsAccountCreationAllowedLoading);

  const state = useAppSelector(selectIsAccountCreationAllowed);

  return {
    handleFetchIsAccountCreationAllowed,
    isAccountCreationAllowed,
    loading,
    state,
  };
};
